import React from 'react'
import { ButtonProps as MaterialButtonProps } from '@mui/material/Button'
import {
  ButtonStyled,
  ButtonLoadingStyled,
  CircularProgressStyled
} from './Button.styles'

export interface ButtonProps extends MaterialButtonProps {
  loading?: boolean
  textTransform?: 'none' | 'uppercase' | 'lowercase' | 'capitalize'
}

export const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  variant = 'contained',
  textTransform = 'capitalize',
  ...rest
}) => {
  if (loading) {
    return (
      <div>
        <ButtonLoadingStyled
          disabled
          variant={variant}
          textTransform={textTransform}
          {...rest}
        >
          <CircularProgressStyled
            size={24}
            colorSpinner={variant === 'contained' ? '#FFFFFF' : '#030096'}
          />
        </ButtonLoadingStyled>
      </div>
    )
  }

  return (
    <div>
      <ButtonStyled variant={variant} textTransform={textTransform} {...rest}>
        {children}
      </ButtonStyled>
    </div>
  )
}
